<script setup lang="ts">
const { result, onSubmit, isSubmitting } = useAuthLogoutForm();
</script>

<template>
  <UiFormWrapper :result="result" @submit="onSubmit">
    <UiSubmitButton :is-submitting="isSubmitting">
      Déconnexion
    </UiSubmitButton>
  </UiFormWrapper>
</template>
